export const LocationReasonDeactivated = Object.freeze({
  YARD_MAINTENANCE: "Yard Maintenance/Repairs",
  AT_CAPACITY: "At Capacity",
  TEMPORARY_CLOSURE: "Temporary Closure",
  SEASONAL_CLOSURE: "Seasonal Closure",
  NOT_AVAILABLE: "Property No Longer Available",
  ECONOMIC: "Pricing/Economics",
  PLATFORM_ISSUE: "Platform/Marketplace Issue",
  SECURITY: "Safety or Security Concern",
  OPERATIONAL: "Access or Operational Issue",
  OTHER: "Other"
});